// import React, { useState } from "react";
// import {
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
//   matchPath,
// } from "react-router-dom";
// import TopNavBar from "../components/navbar/topnav/topNavBar";
// import BottomNav from "../components/navbar/bottomnav/bottomNav";
// import MasterPage from "../pages/masterpage";
// import Map from "../pages/map";
// import Modal from "../components/modal/form-modal/modal";
// import InteractiveTour from "../pages/interactive/interactiveTour";
// import ExploreTour from "../pages/tourpage/ExploreTour";
// // استيراد الـ ZoneProvider فقط ليكون عاماً
// import { ZoneProvider } from "../context/ZoneContext";
// import { FilterProvider } from "../context/FilterContext";
// import { RangeFilterProvider } from "../context/rangeFilterContext";
// import { TabsFilterProvider } from "../context/TabsFilterContext";
// function AppRouts({ lang, btnLang, units }) {
//   // console.log("AppRouts received lang:", lang);
//   const location = useLocation();

//   // استخراج zoneId من المسار يدوياً ليمرر للـ Provider
//   // const match = matchPath({ path: "/master-plan/:zoneId" }, location.pathname);
//   // const zoneIdFromPath = match ? parseInt(match.params.zoneId, 10) : null;
//   // 1. هنجرب نطابق المسار العادي بتاع الـ Master
//   // const matchMaster = matchPath(
//   //   { path: "/master-plan/:zoneId" },
//   //   location.pathname,
//   // );

//   // // 2. هنجرب نطابق المسار الجديد بتاع الفيلا
//   // const matchVilla = matchPath(
//   //   { path: "/master-plan/:zoneId/villa/:unitCode" },
//   //   location.pathname,
//   // );
// // 1. هنجرب نطابق المسار العادي بتاع الـ Master
//   const matchMaster = matchPath(
//     { path: "/master-plan/:zoneId" },
//     location.pathname,
//   );

//   // 2. 🎯 التعديل هنا: ضيفي النجمة (*) أو الـ floorName الاختياري
//   // عشان الـ Match ينجح حتى لو فيه كلام زيادة في الآخر
//   const matchVilla = matchPath(
//     { path: "/master-plan/:zoneId/villa/:unitCode/*" }, // النجمة بتخليها تقبل أي حاجة بعدها
//     location.pathname,
//   );

//   // 3. هناخد الـ ID من أي واحد فيهم ينجح
//   const activeMatch = matchMaster || matchVilla;
//   const zoneIdFromPath = activeMatch
//     ? parseInt(activeMatch.params.zoneId, 10)
//     : null;
    
//   console.log("📍 Captured ZoneID:", zoneIdFromPath); // حطي ده عشان تتأكدي في الكونسول
//   // // 3. هناخد الـ ID من أي واحد فيهم ينجح
//   // const activeMatch = matchMaster || matchVilla;
//   // const zoneIdFromPath = activeMatch
//   //   ? parseInt(activeMatch.params.zoneId, 10)
//   //   : null;

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isRadiusVisible, setIsRadiusVisible] = useState(false);
//   const [showPlaces, setShowPlaces] = useState(true);
//   const [showRoads, setShowRoads] = useState(false);
//   const [isDevsActive, setIsDevsActive] = useState(false);
//   const [isOverlayHidden, setIsOverlayHidden] = useState(false);

//   const [filterSelection, setFilterSelection] = useState({
//     mode: "type",
//     data: [],
//   });

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   const toggleRadiusVisibility = () => setIsRadiusVisible((prev) => !prev);
//   const handleHideRadius = () => setIsRadiusVisible(false);

//   const toggleOverlay = () => {
//     if (
//       ["/", "/master-plan"].includes(location.pathname) ||
//       location.pathname.includes("/master-plan")
//     ) {
//       setIsOverlayHidden((prev) => !prev);
//     }
//   };

//   const togglePlacesVisibility = (value) =>
//     setShowPlaces((prev) => (typeof value === "boolean" ? value : !prev));

//   const toggleRoadsVisibility = (value) =>
//     setShowRoads((prev) => (typeof value === "boolean" ? value : !prev));

//   const showNavs =
//     location.pathname === "/" || location.pathname.includes("master-plan");

//   return (
//     <ZoneProvider zoneId={zoneIdFromPath} lang={lang}>
//           <TabsFilterProvider setFilterSelection={setFilterSelection}>
//       <FilterProvider>
//         <RangeFilterProvider>
//             <TopNavBar
//               lang={lang}
//               btnLang={btnLang}
//               onCallbackClick={openModal}
//               onShowRadiusClick={toggleRadiusVisibility}
//               hideShowRadius={isRadiusVisible}
//               onToggleOverlay={toggleOverlay}
//               isOverlayHidden={isOverlayHidden}
//               page={location.pathname}
//             />

//             <Modal lang={lang} show={isModalOpen} onClose={closeModal} />

//             <Routes>
//               <Route
//                 path="/"
//                 element={
//                   <Map
//                     lang={lang}
//                     isRadiusVisible={isRadiusVisible}
//                     showPlaces={showPlaces}
//                     showRoads={showRoads}
//                     onHideRadius={handleHideRadius}
//                     isOverlayHidden={isOverlayHidden}
//                     onLandmarksClick={togglePlacesVisibility}
//                     onRoadsClick={toggleRoadsVisibility}
//                     isDevsActive={isDevsActive}
//                     setIsDevsActive={setIsDevsActive}
//                   />
//                 }
//               />

//               <Route
//                 path="/master-plan/:zoneId"
//                 element={
//                   <MasterPage
//                     lang={lang}
//                     isOverlayHidden={isOverlayHidden}
//                     filterSelection={filterSelection}
//                     setFilterSelection={setFilterSelection}
//                   />
//                 }
//               />
//               {/* // في ملف AppRouts.js - غيري السطر ده: */}
//               {/* <Route
//                 path="/master-plan/:zoneId/villa/:unitCode"
//                 element={<ExploreTour lang={lang} />}
//               /> */}
//               {/* // في ملف AppRouts.js - عدلي السطر الخاص بـ ExploreTour */}
// <Route
//   path="/master-plan/:zoneId/villa/:unitCode/:floorName?" 
//   element={<ExploreTour lang={lang} />}
// />
//               {/* <Route path="/explore-tour" element={<ExploreTour lang={lang} />} /> */}
//               <Route
//                 path="/master-plan/:zoneId/villa/:unitCode/tour/index.html"
//                 element={<InteractiveTour lang={lang} />}
//               />
//               {/* <Route
//                 path="/interactive-tour"
//                 element={<InteractiveTour lang={lang} />}
//               /> */}
//               <Route path="*" element={<Navigate to="/" />} />
//             </Routes>

//             {showNavs && (
//               <BottomNav
//                 lang={lang}
//                 btnLang={btnLang}
//                 onCallbackClick={openModal}
//                 onShowRadiusClick={toggleRadiusVisibility}
//                 hideShowRadius={isRadiusVisible}
//                 onToggleOverlay={toggleOverlay}
//                 isOverlayHidden={isOverlayHidden}
//                 page={location.pathname}
//                 onLandmarksClick={togglePlacesVisibility}
//                 onRoadsClick={toggleRoadsVisibility}
//                 showPlaces={showPlaces}
//                 showRoads={showRoads}
//                 isDevsActive={isDevsActive}
//                 onDevsClick={() => setIsDevsActive((prev) => !prev)}
//                 onFilterChange={setFilterSelection}
//                 filterSelection={filterSelection}
//                 isExploreTour={location.pathname.includes("/villa/")}
//               />
//             )}
//         </RangeFilterProvider>
//       </FilterProvider>
//           </TabsFilterProvider>
//     </ZoneProvider>
//   );
// }

// export default AppRouts;
import React, { useState, useEffect, useMemo } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  matchPath,
} from "react-router-dom";
import TopNavBar from "../components/navbar/topnav/topNavBar";
import BottomNav from "../components/navbar/bottomnav/bottomNav";
import MasterPage from "../pages/masterpage";
import Map from "../pages/map";
import Modal from "../components/modal/form-modal/modal";
import InteractiveTour from "../pages/interactive/interactiveTour";
import ExploreTour from "../pages/tourpage/ExploreTour";
import { ZoneProvider } from "../context/ZoneContext";
import { FilterProvider } from "../context/FilterContext";
import { RangeFilterProvider } from "../context/rangeFilterContext";
import { TabsFilterProvider } from "../context/TabsFilterContext";

function AppRouts({ lang, btnLang, units }) {
  const location = useLocation();
useEffect(() => {
    // دي الخطوة اللي بتخلي الـ CSS "يشوف" اللغة
    document.documentElement.lang = lang; 
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  // 1. منطق استخراج الـ ProjectSlug والـ ZoneID بشكل آمن
  const routeData = useMemo(() => {
    // محاولة مطابقة المسار العام للمشروع أولاً لضمان وجود slug
    const projectMatch = matchPath({ path: "/:projectSlug/*" }, location.pathname);
    
    // محاولة مطابقة مسارات الـ Zone
    const masterMatch = matchPath({ path: "/:projectSlug/master-plan/:zoneId" }, location.pathname);
    const villaMatch = matchPath({ path: "/:projectSlug/master-plan/:zoneId/villa/:unitCode/*" }, location.pathname);

    const activeZoneMatch = masterMatch || villaMatch;

    return {
      slug: projectMatch?.params?.projectSlug || null,
      zoneId: activeZoneMatch ? parseInt(activeZoneMatch.params.zoneId, 10) : null
    };
  }, [location.pathname]);

  // طباعة لمراقبة الحالة في الكونسول
  console.log("🚀 Current Project Slug:", routeData.slug);
  console.log("📍 Current Zone ID:", routeData.zoneId);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRadiusVisible, setIsRadiusVisible] = useState(false);
  const [showPlaces, setShowPlaces] = useState(true);
  const [showRoads, setShowRoads] = useState(false);
  const [isDevsActive, setIsDevsActive] = useState(false);
  const [isOverlayHidden, setIsOverlayHidden] = useState(false);

  const [filterSelection, setFilterSelection] = useState({
    mode: "type",
    data: [],
  });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const toggleRadiusVisibility = () => setIsRadiusVisible((prev) => !prev);
  const handleHideRadius = () => setIsRadiusVisible(false);

  const toggleOverlay = () => {
    if (location.pathname.includes("/master-plan")) {
      setIsOverlayHidden((prev) => !prev);
    }
  };

  const togglePlacesVisibility = (value) =>
    setShowPlaces((prev) => (typeof value === "boolean" ? value : !prev));

  const toggleRoadsVisibility = (value) =>
    setShowRoads((prev) => (typeof value === "boolean" ? value : !prev));

  // شرط إظهار النيفبار: لا يظهر في الصفحة الرئيسية (اختيار المشروع) ولا في التور الداخلي
  const showNavs = location.pathname !== "/" && !location.pathname.includes("tour/index.html");

  return (
    <ZoneProvider zoneId={routeData.zoneId} lang={lang}>
      <TabsFilterProvider setFilterSelection={setFilterSelection}>
        <FilterProvider>
          <RangeFilterProvider>
            {/* التوب بار */}
            <TopNavBar
              lang={lang}
              btnLang={btnLang}
              onCallbackClick={openModal}
              onShowRadiusClick={toggleRadiusVisibility}
              hideShowRadius={isRadiusVisible}
              onToggleOverlay={toggleOverlay}
              isOverlayHidden={isOverlayHidden}
              page={location.pathname}
            />

            <Modal lang={lang} show={isModalOpen} onClose={closeModal} />

            <Routes>
              {/* التوجيه من الجزر الرئيسي للمشروع الافتراضي */}
              <Route path="/" element={<Navigate to="/sadan" replace />} />

              {/* هيكلة المسارات الديناميكية بناءً على الـ Slug */}
              <Route path="/:projectSlug">
                {/* خريطة المشروع */}
                <Route
                  index
                  element={
                    <Map
                      lang={lang}
                      isRadiusVisible={isRadiusVisible}
                      showPlaces={showPlaces}
                      showRoads={showRoads}
                      onHideRadius={handleHideRadius}
                      isOverlayHidden={isOverlayHidden}
                      onLandmarksClick={togglePlacesVisibility}
                      onRoadsClick={toggleRoadsVisibility}
                      isDevsActive={isDevsActive}
                      setIsDevsActive={setIsDevsActive}
                    />
                  }
                />

                {/* صفحة الـ Master Plan لكل Zone */}
                <Route
                  path="master-plan/:zoneId"
                  element={
                    <MasterPage
                      lang={lang}
                      isOverlayHidden={isOverlayHidden}
                      filterSelection={filterSelection}
                      setFilterSelection={setFilterSelection}
                    />
                  }
                />

                {/* صفحة استكشاف الفيلا */}
                <Route
                  path="master-plan/:zoneId/villa/:unitCode/:floorName?"
                  element={<ExploreTour lang={lang} />}
                />

                {/* التور التفاعلي */}
                <Route
                  path="master-plan/:zoneId/villa/:unitCode/tour/index.html"
                  element={<InteractiveTour lang={lang} />}
                />
              </Route>

              {/* إعادة توجيه في حالة كتابة مسار خاطئ */}
              <Route path="*" element={<Navigate to="/sadan" replace />} />
            </Routes>

            {/* البوتوم ناف */}
            {showNavs && (
              <BottomNav
                lang={lang}
                btnLang={btnLang}
                onCallbackClick={openModal}
                onShowRadiusClick={toggleRadiusVisibility}
                hideShowRadius={isRadiusVisible}
                onToggleOverlay={toggleOverlay}
                isOverlayHidden={isOverlayHidden}
                page={location.pathname}
                onLandmarksClick={togglePlacesVisibility}
                onRoadsClick={toggleRoadsVisibility}
                showPlaces={showPlaces}
                showRoads={showRoads}
                isDevsActive={isDevsActive}
                onDevsClick={() => setIsDevsActive((prev) => !prev)}
                onFilterChange={setFilterSelection}
                filterSelection={filterSelection}
                isExploreTour={location.pathname.includes("/villa/")}
              />
            )}
          </RangeFilterProvider>
        </FilterProvider>
      </TabsFilterProvider>
    </ZoneProvider>
  );
}

export default AppRouts;